import React from 'react';
import {Accordion} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';
import EstimatePanel from './panels/EstimatePanel';
import DocumentSectionsPanel from './panels/DocumentSectionsPanel';
import BrandingPanel from './panels/BrandingPanel';
import LayoutThemePanel from './panels/LayoutThemePanel';
import type {PanelProps} from './panels/types';

/**
 * The four configuration panels, in the order the design fixes: Estimate, Document Sections,
 * Branding, Layout & Theme.
 *
 * Only Estimate is expanded on entry — carried through unchanged from the POC, and worth stating
 * because the reorder moved it to the top. MULTIPLE lets the user open several at once thereafter.
 */
const SettingsPanel: React.FC<PanelProps> = props => {
	const intl = useIntl();

	return (
		<Accordion selectionType={Accordion.SelectionType.MULTIPLE} background={false} defaultValue="estimate">
			<Accordion.Item
				value="estimate"
				label={intl.formatMessage({id: 'quote_designer.section.estimate'})}
				content=""
				data-cy="quote-section-estimate"
			>
				<EstimatePanel {...props} />
			</Accordion.Item>

			<Accordion.Item
				value="documents"
				label={intl.formatMessage({id: 'quote_designer.section.documents'})}
				content=""
				data-cy="quote-section-documents"
			>
				<DocumentSectionsPanel {...props} />
			</Accordion.Item>

			<Accordion.Item
				value="branding"
				label={intl.formatMessage({id: 'quote_designer.section.branding'})}
				content=""
				data-cy="quote-section-branding"
			>
				<BrandingPanel {...props} />
			</Accordion.Item>

			<Accordion.Item
				value="layout"
				label={intl.formatMessage({id: 'quote_designer.section.layout_theme'})}
				content=""
				data-cy="quote-section-layout"
			>
				<LayoutThemePanel {...props} />
			</Accordion.Item>
		</Accordion>
	);
};

export default SettingsPanel;
